import React, { useEffect, useState } from "react";

import "./NewPage.css";
import { FaBriefcase } from "react-icons/fa";
import CanvasJSReact from '@canvasjs/react-charts';

var CanvasJSChart = CanvasJSReact.CanvasJSChart;

const NewPage = () => {
  const [showGraphs, setShowGraphs] = useState(false);
  const [activeTab, setActiveTab] = useState("Data Scientist");

  useEffect(() => {
    const handleScroll = () => {
      const graphSection = document.querySelector(".gr-ds-graph");
      const graphPosition = graphSection.getBoundingClientRect().top;
      const screenPosition = window.innerHeight / 1.3;

      if (graphPosition < screenPosition) {
        setShowGraphs(true);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const options = {
    animationEnabled: true,
    exportEnabled: true,
    theme: "light2",
    title: {
      text: "Annual Average Salaries"
    },
    axisY: {
      includeZero: true
    },
    data: [{
      type: "column",
      indexLabelFontColor: "#5A5757",
      indexLabelPlacement: "outside",
      dataPoints: [
        { label: "Min (5L)", y: 5 },
        { label: "Average (8L)", y: 8 },
        { label: "Max (24L)", y: 24 }
      ]
    }]
  };

  return (
    <div className="gr-ds-data-science">
      <h4>Why Data Science Bootcamp?</h4>
      <h1>
        <span>Rising Demand</span> for analytics and AI Skills and Career Growth
      </h1>
      <div className="gr-ds-tabs">
        {/* {["Data Analyst", "Data Scientist"].map((tab) => (
          <span
            key={tab}
            className={activeTab === tab ? "gr-ds-selected-tab" : "gr-ds-inactive-tab"}
            onClick={() => handleTabClick(tab)}
          >
            {tab}
          </span>
        ))} */}
      </div>
      <div className="gr-ds-container">
        <div className="gr-ds-graph">
          {showGraphs && <CanvasJSChart options={options} />}
        </div>
        <div className="gr-ds-companies">
          <h3>Top Companies Hiring</h3>
          <div className="gr-ds-company-list">
            {["amazon", "axis bank", "accenture", "careers 360", "Capgemini", "CitiusTech", "EY", "Deloitte", "cognizant", "fractal"].map((company, index) => (
              <span key={index} className="gr-ds-animated-company" style={{ "--delay": index }}>
                {company}
              </span>
            ))}
          </div>
        </div>
        <div className="gr-ds-demand">
          <h3>Demand</h3>
          <div className="gr-ds-demand-card">
            <FaBriefcase className="gr-ds-icon" />
            <p>14% Growth in Data Scientist Job Roles by 2028</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewPage;
